import http_request from './http_request'
import config from 'config'

function getGoalsData() {
	return http_request.get(`${config.api}goals`)
		.send()
}

function publishLesson(presentationId) {
	return http_request.put(`${config.api}presentation/${presentationId}/publish`)
		.send()
}

function enableLesson(presentationId) {
	return http_request.put(`${config.api}presentation/${presentationId}/undelete`)
		.send()
}

function createLessonOeq() {
	return http_request.post(`${config.api}goals/oeq`)
		.send()
}

export default {
	getGoalsData,
	enableLesson,
	createLessonOeq,
	publishLesson,
}
